const headerData = [
    {
      prop: "id",
      label: "序号",
      columnwidth: 50,
    },
    {
      prop: "HPCode", 
      label: "医院编号",
      columnwidth: 120,
    },
    {
      prop: "HPName", 
      label: "医院名称",
      columnwidth: 180,
    },
    {
      prop: "UsedName", 
      label: "曾用名",
      columnwidth: 120,
    },
    {
      prop: "HosGradeName",
      label: "医院等级",
      columnwidth: 90,
    },
    {
      prop: "Province",
      label: "省份",
      columnwidth: 120,
    },
    {
      prop: "City",
      label: "城市",
      columnwidth: 120,
    },
    {
      prop: "District",
      label: "区县",
      columnwidth: 120,
    },
    {
      prop: "Address",
      label: "地址",
      columnwidth: 250,
    },
    {
      prop: "InvClassName", 
      label: "产品线",
      columnwidth: 120,
    },
    {
      prop: "CountryMan", 
      label: "全国总监",
      columnwidth: 120,
    },
    {
      prop: "RegionMan", 
      label: "大区经理",
      columnwidth: 120,
    },
    {
      prop: "AreaMan", 
      label: "地区经理",
      columnwidth: 120,
    },
    {
      prop: "SalesMan", 
      label: "销售人员",
      columnwidth: 120,
    },{
      prop: "CreateTime",
      label: "创建时间",
      columnwidth: 120,
    },
  ];
  export default headerData
